import React from "react";

const Header = () => {
  return (
    <header>
      <div className="container">
        <div className="header-content">
          <div className="logo">Devanshi Corporation</div>
          <div className="company-info">
            <div>
              📍 Mumbai, Maharashtra | 📞 Contact: +91-9920850545 | GST:
              27AAEHP0870M1ZU
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
